export default __webpack_public_path__ + "static/media/order.2dee3009.png";